import { AUTH_TOKEN_NAME } from "./constants";
import Storage from "./storage";

export default class Auth {
    static set token(token) {
      Storage.token = token;
    }
  
    static get token() {
      return Storage.token;
    }
  
    static logout() {
      Storage.remove(AUTH_TOKEN_NAME);
      // history.push(LOGIN_URL);
    //   window.location.href = LOGIN_URL;
    }
  }